import { boolean, date, number, object, string } from 'yup';
import * as yup from 'yup';

export const workExperieneceFormValidator = () => {
  return yup.object({
    facilityName: string().required().max(100, 'Max 100 Characters'),
    zipCode: string()
      .nullable()
      .when('country', {
        is: value => value?.id === 1,
        then: schema => schema.max(5, 'Max 5 Characters'),
        otherwise: schema => schema.max(20, 'Max 20 Characters'),
      }),
    discipline: object().when('$shouldDisableEdit', {
      is: value => value,
      then: schema => schema.notRequired().nullable(),
      otherwise: schema => schema.required(),
    }),
    specialty: string().when('$shouldDisableEdit', {
      is: value => value,
      then: schema => schema.notRequired().nullable(),
      otherwise: schema => schema.required(),
    }),
    currentlyWorkingIsCurrentlyWorking: boolean().required(),
    currentlyWorkingStartDate: date()
      .required()
      .test('format', 'Invalid Date', date => (date?.getFullYear() ?? 0) >= 1753 && (date?.getFullYear() ?? 0) <= 9999),
    currentlyWorkingEndDate: date()
      .min(yup.ref('currentlyWorkingStartDate'), 'End Date can not be before Start Date')
      .when('currentlyWorkingIsCurrentlyWorking', {
        is: value => value === true,
        then: schema => schema.notRequired().nullable(),
        otherwise: schema => schema.required(),
      }),
    currentlyWorkingReasonForLeaving: string()
      .max(50, 'Max 50 Characters')
      .when('currentlyWorkingIsCurrentlyWorking', {
        is: value => value === true,
        then: schema => schema.notRequired().nullable(),
        otherwise: schema => schema.required("Required"),
      }),
    numberOfBedsInFacility: number().max(9999).min(0).nullable(),
    unitFloorDepartment: string().max(50, 'Max 50 Characters').nullable(),
    positionHeld: string().max(50, 'Max 50 Characters').nullable(),
    isSupervisor: boolean(),
    isTeleTherapy: boolean(),
    isTeachingHospital: boolean(),
    isLocalStaffingAgency: boolean(),
    epnotes: string().max(1000, 'Max 1000 Characters'),
    workHistoryId: number(),
    placementId: number(),
    position: string(),
    approvedReferenceCount: number(),
    timeStamp: string(),
    location: object(),
    previousEndedOn: object(),
  });
};
